'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';

import { POSTHOG_INGEST_ORIGIN } from '@/lib/security';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Skip PostHog in non-production to avoid proxy errors
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    if (!posthogKey) {
      console.warn('PostHog key not found');
      return;
    }

    // Only initialize if not already initialized
    if (!posthog.__loaded) {
      posthog.init(posthogKey, {
        // The SAME origin security.ts puts in the CSP. Hardcoding it here
        // meant setting NEXT_PUBLIC_POSTHOG_HOST to anything else CSP-blocked
        // every event and capture_exceptions report from the signed-out funnel
        // (sign-in, sign-up, marketing) while the authenticated app kept
        // working — the two providers disagreeing is invisible until it isn't.
        api_host: POSTHOG_INGEST_ORIGIN,
        ui_host: 'https://us.posthog.com',
        capture_exceptions: true,
        person_profiles: 'always',
      });
    }
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
